import { createSlice } from "@reduxjs/toolkit";
import { fetchMiniTitle } from "../actions/miniTitleAction";
// import { ILoginInitialState } from "../states/loginState";
import { REHYDRATE } from "redux-persist";

const initialState = {
  data: {
    id: 0,
    title_01: "",
    title_02: "",
    title_03: "",
    title_04: "",
    title_05: "",
    created_user_id: 0,
    created_user_name: "",
    created_date: "",
    updated_user_id: 0,
    updated_user_name: "",
    updated_date: "",
  },
  isLoading: false,
  error: false,
};

export const miniTitleSlice = createSlice({
  name: "miniTitle",
  initialState,
  reducers: {
    miniTitle: (state, action) => {
      state.data = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchMiniTitle.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(fetchMiniTitle.fulfilled, (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    });
    builder.addCase(fetchMiniTitle.rejected, (state) => {
      state.isLoading = false;
    });
    builder.addCase(REHYDRATE, (state) => {
      const { data } = state;
      state.isLoading = false;
      state.data = data;
    });
  },
});

export const { miniTitle } = miniTitleSlice.actions;

export default miniTitleSlice.reducer;
